import React from 'react';
import Modal from '@components/Modal';
import { Translate } from 'react-redux-i18n';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import * as yup from 'yup';
import { confirmPasswordRule, nameRule, passwordRule } from './validation';

const schema = yup.object().shape({
  name: nameRule,
  password: passwordRule,
  confirmPassword: confirmPasswordRule,
});

const AddChild = ({ show, close, onSave }) => {
  const { register, handleSubmit, formState } = useForm({
    mode: 'all',
    resolver: yupResolver(schema),
  });

  const onSubmit = data => onSave(data);
  const { errors } = formState;

  return (
    <Modal
      show={show}
      close={close}
      hideClose={true}
      dialogClassName="with-robot-head"
      id="modal-editProfile"
    >
      <div className="row modal-robot-body text-center ">
        <div className="robot-head">
          <img
            src={require('../../../assets/images/robot-green-happy-head.svg')}
            alt="progkids-green-robot"
          />
        </div>
        <br />

        <form
          onSubmit={handleSubmit(onSubmit)}
          className="col-xs-12 form-group"
        >
          <div className={`form-group`}>
            <span>Игровой ник:</span>
            <input
              type="text"
              className="form-control"
              autoComplete="username"
              {...register('name')}
            />
            <span className="help-block-error">
              {(errors['name'] || {}).message}
            </span>
          </div>
          <div className={`form-group`}>
            <span>Имя:</span>
            <input
              type="text"
              className="form-control"
              {...register('realname')}
            />
          </div>
          <div className={`form-group`}>
            <span>Возраст:</span>
            <input type="text" className="form-control" {...register('age')} />
          </div>
          <div className={`form-group`}>
            <span>Новый пароль:</span>
            <input
              type="password"
              className="form-control"
              {...register('password')}
            />
            <span className="help-block-error">
              {(errors['password'] || {}).message}
            </span>
          </div>
          <div className={`form-group`}>
            <span>Повторите новый пароль:</span>
            <input
              type="password"
              className="form-control"
              {...register('confirmPassword')}
            />
            <span className="help-block-error">
              {(errors['confirmPassword'] || {}).message}
            </span>
          </div>
          <button className="btn btn-green-small text-uppercase" type="submit">
            <Translate value="settings.personal.children.createAccount" />
          </button>
        </form>
      </div>
    </Modal>
  );
};

export default AddChild;
